import httpClient from "../http/http-client";
import { IReductionTarget, IReductionTargetGraphResponse } from './reduction-target.model';

export default class ReductionTargetService {
  http;

  constructor() {
    this.http = httpClient
  }

  async getReductionTargets(): Promise<IReductionTarget[]> {
    return this.http.get('reduction-target')
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err)
        throw err
      });
  }


  async getReductionTargetsGraphData(scope: 'total' | '1' | '2' | '3', scopeTwoMethod?: 'market-based' | 'location-based'): Promise<IReductionTargetGraphResponse> {
    const params = new URLSearchParams({ scope })
    if (scopeTwoMethod) params.set('scopeTwoMethod', scopeTwoMethod)
    return this.http.get(`reduction-target/graph-data?${params.toString()}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err)
        throw err
      })
  }
}